import { PropTypes } from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const TextArea = styled.textarea`
  ${(props) => props.type === 'memo' && css`
    position: absolute;
    top: 40px;
    left: 10px;
    width: 298px;
    height: 282px;
    padding: 0 7px 15px 15px;
    border: 0px;
    outline: medium;
    background: transparent;
    font-size: 20px;
    resize: none;
    overflow-y: scroll;

    &:focus-visible {
      outline-offset: 0px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #fdce00;
    }
  `}
`;

export const Text = (props) => {
  return (
    <TextArea 
      type={props.type} 
      tabIndex={props.tabIndex} 
      maxLength={props.maxLength}
      onChange={props.onChange}
    >
      {props.children}
    </TextArea>
  );
};

Text.propTypes = {
  type : PropTypes.string,
  tabIndex : PropTypes.number,
  maxLength : PropTypes.number
};

Text.defaultProps = {
  type : 'memo',
  tabIndex : 100,
  maxLength : 1000
};